export const ZOOM_ENABLING_DELAY = 400;
export const ZOOM_FACTOR = 3;
export const FREE_SPACE = 300;
export const MAGNIFYING_GLASS_FRAME_ID = 'magnifying-glass-frame';
export const Z_INDEX = 1042;
export const MAGNIFYING_GLASS_FRAME_SIZE = 675;
export const MAGNIFYING_GLASS_BORDER_SIZE = 1;
export const FALLBACK_MAGNIFYING_GLASS_FRAME_HEIGHT = MAGNIFYING_GLASS_FRAME_SIZE - MAGNIFYING_GLASS_BORDER_SIZE * 2;
export const FALLBACK_MAGNIFYING_GLASS_FRAME_WIDTH = 544;
